// extracted by mini-css-extract-plugin
module.exports = {"news":"News_news__1L6PA","newsWrapper":"News_newsWrapper__2JTjY","logo":"News_logo__3_rLy","content":"News_content__1sWfk"};